



























































import { Component, Prop, Vue } from "vue-property-decorator";

import { Match } from "@/types";
import { State } from "vuex-class";
import MatchList from "@/components/MatchList.vue";

@Component({
  components: { MatchList }
})
export default class DocumentSummary extends Vue {
  relationships: { [key: string]: string } = {
    "Indicated prescriptions": "indications",
    "Contraindicated prescriptions": "contraindications",
    "Off-label prescriptions": "off_label_uses"
  };

  @Prop()
  private sectionClass!: any;

  @Prop({ default: () => "" })
  private text!: string;

  @Prop({ default: () => [] })
  private matches!: Match[];

  asList(matches: Match[]) {
    return matches.filter(
      (item, index, array) =>
        array.findIndex(
          candidate =>
            candidate.concept.text.phrase === item.concept.text.phrase ||
            candidate.concept.conceptid === item.concept.conceptid
        ) === index
    );
  }

  asString(matches: Match[]) {
    return matches
      .map(match =>
        this.document
          .slice(...match.concept.text.charpos)
          .replace("\n", " ")
          .toLowerCase()
      )
      .join(", ");
  }

  get chiefComplaints() {
    return this.matches.filter(
      match => match.labels && match.labels.includes("chief_complaint")
    );
  }

  get principalDiagnosis() {
    return this.matches.filter(
      match => match.labels && match.labels.includes("principal_diagnosis")
    );
  }

  prescriptions(key: string) {
    return this.matches
      .filter(match => match.relationships && key in match.relationships)
      .filter((item, index, array) => {
        return (
          array.findIndex(
            candidate =>
              candidate.concept.text.phrase === item.concept.text.phrase ||
              candidate.concept.conceptid === item.concept.conceptid
          ) === index
        );
      })
      .sort((a, b) =>
        a.concept.text.phrase.localeCompare(b.concept.text.phrase)
      );
  }

  get document() {
    return this.text || this.$store.state.text;
  }
}
